<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt="images" src="images/co.jpg"/></p>
<p class="break"> </p>
<p class="break"> </p>
<div class="big1">
<p class="noindent1"><a href="#/chapter1">a Word from Mallory</a></p>
<p class="noindent1"><a href="#/chapter2"> The Sleepover</a></p>
<p class="noindent1"><span href="#/chapter3" title="Link target outside of Sample">Mallory + Jake</span></p>
<p class="noindent1"><span href="#/chapter4" title="Link target outside of Sample">On the Phone</span></p>
<p class="noindent1"><span href="#/chapter5" title="Link target outside of Sample">a Sign</span></p>
<p class="noindent1"><span href="#/chapter6" title="Link target outside of Sample">Once Upon a Time</span></p>
<p class="noindent1"><span href="#/chapter7" title="Link target outside of Sample">Dr. Mary Ann</span></p>
<p class="noindent1"><span href="#/chapter8" title="Link target outside of Sample">Eenie, Meenie, Miney, Go</span></p>
<p class="noindent1"><span href="#/chapter9" title="Link target outside of Sample">Party Prep</span></p>
<p class="noindent1"><span href="#/chapter10" title="Link target outside of Sample">The Party </span></p>
<p class="noindent1"><span href="#/chapter11" title="Link target outside of Sample">BIG Trouble</span></p>
<p class="noindent1"><span href="#/chapter12" title="Link target outside of Sample">“a” Is for...</span></p>
<p class="noindent1"><span href="#/chapter13" title="Link target outside of Sample">Breaking Up</span></p>
<p class="noindent1"><span href="#/chapter14" title="Link target outside of Sample">Recipe for a Perfect Day</span></p>
<p class="noindent1"><span href="#/chapter15" title="Link target outside of Sample">Photos</span></p>
<p class="noindent1"><span href="#/chapter16" title="Link target outside of Sample">A Quiz</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter3.vue?7e99e9ce